export const ERROR_DUPLICATE_USERNAME = 'ERROR_DUPLICATE_USERNAME';
export const SET_EMAIL = 'SET_EMAIL';
export const CLEAR_PATIENT_DATA = 'CLEAR_PATIENT_DATA';
export const CLEAR_PASSWORD = 'CLEAR_PASSWORD';
